import { FirebaseApp, initializeApp, getApps } from "firebase/app";
import { firebaseClientConfig } from "config/firebase";
import {
  logEvent,
  EventNameString,
  getAnalytics,
  EventParams,
  AnalyticsCallOptions,
} from "firebase/analytics";

// Utils
import { sentryErrorLog } from "./sentryLog";

let _fbApp: FirebaseApp | undefined = undefined;

if (typeof window !== "undefined" && getApps().length <= 0) {
  _fbApp = initializeApp(firebaseClientConfig, {
    automaticDataCollectionEnabled: true,
  });
}

export const fbApp = _fbApp;

export const trackEvent = (
  eventName: EventNameString | string,
  eventParams: EventParams = {},
  options?: AnalyticsCallOptions
) => {
  let address: string | undefined = undefined;
  if (typeof window !== "undefined" && "ethereum" in window) {
    address = (window as any).ethereum?.selectedAddress;
  }

  try {
    (window as any).rudderanalytics.track(eventName, {
      address,
      ...eventParams,
      dapp: "binance",
    });
  } catch (e) {
    sentryErrorLog(e);
  }

  try {
    const analytics = getAnalytics(_fbApp);
    logEvent(analytics, eventName, { ...eventParams }, options);
  } catch (e) {
    sentryErrorLog(e);
  }
};
